import { useState } from 'react';
import { useUser, useUpdateUser } from '@/hooks/useUser';
import Input from '@/components/common/Input';
import Button from '@/components/common/Button';

export default function SettingsForm() {
  const { data: user } = useUser();
  const updateUser = useUpdateUser();
  const [displayName, setDisplayName] = useState(user?.display_name || '');
  const [saved, setSaved] = useState(false);

  const handleSave = async () => {
    try {
      await updateUser.mutateAsync({ display_name: displayName });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch {
      // Error handled by mutation
    }
  };

  return (
    <section className="space-y-4">
      <h2 className="text-lg font-semibold text-neutral-900">Profile</h2>

      <Input
        label="Email"
        value={user?.email || ''}
        disabled
        helperText="Email cannot be changed"
      />

      <Input
        label="Display Name"
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
        placeholder="Your name"
      />

      <div className="flex items-center gap-3">
        <Button onClick={handleSave} loading={updateUser.isPending}>
          Save Changes
        </Button>
        {saved && <span className="text-sm text-success-600">Saved!</span>}
      </div>
    </section>
  );
}
